import axios from '../../../services/axios-config';


export async function getSystemParams(){
    try{
        const res = await axios.get('/admin/params');

        if(res.status == 200){
            return res.data;
        }

    } catch (error) {
        throw error;
    }
}